import { Box, CircularProgress, Typography } from "@mui/material";
import { t } from "i18next";
import { formatCurrency, getInstructionByPaymentProvider } from "../../utils";
import { useDimensions } from "../../hooks";
import Card from ".";

const LoadingCard = ({
  totalAmount,
  currency,
  phoneNumber,
}: {
  totalAmount: string;
  // The unit the pay response named. Absent on a reload, where the session
  // holds neither the amount nor its unit.
  currency?: string;
  phoneNumber?: string;
}) => {
  const { isSmall } = useDimensions();
  const maxWidth = isSmall ? "unset" : "38%";

  return (
    <Box sx={{ maxWidth }}>
      <Card
        sx={{
          display: "flex",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          padding: isSmall ? 5 : 10,
        }}
      >
        <Box>
          <Box display={"flex"} justifyContent={"center"}>
            <CircularProgress color="primary" title="loading" />
          </Box>
          <Typography
            fontSize={16}
            fontWeight={600}
            textAlign={"center"}
            color="primary"
            paddingBottom={3}
          >
            {t("stepper_3.please_wait")}
          </Typography>

          <Typography fontSize={32} fontWeight={600} textAlign={"center"}>
            {t("stepper_3.waiting_payment")}
          </Typography>
          <Typography
            textAlign={"center"}
            sx={{ fontWeight: "400", fontSize: 20, color: "#707070" }}
            paddingBottom={5}
          >
            {t("stepper_3.payment_notif")}
          </Typography>
          {Number(totalAmount) > 0 && (
            <Typography
              textAlign={"center"}
              fontSize={24}
              fontWeight={700}
              paddingBottom={2}
              sx={{ marginTop: -3 }}
            >
              {formatCurrency(totalAmount, undefined, currency)}
            </Typography>
          )}
          <Typography
            textAlign={"center"}
            fontSize={14}
            fontWeight={400}
            color={"#707070"}
          >
            {t(getInstructionByPaymentProvider(phoneNumber))}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default LoadingCard;
